import { useQuery } from "@tanstack/react-query";

import { useAppContext } from "./useAppContext";
import { useDefinition } from "./useDefinition";
import { useErrorHandling } from "./useErrorHandling";

/** Symbols for this product, this is fetched from the server */
export function useSymbols() {
	const { client, reactQueryNoReloadOptions } = useAppContext();
	const definition = useDefinition();
	const { createErrorHandler } = useErrorHandling();

	const loadSymbols = async () => {
		if (!definition) return [];

		const symbols =
			(await client.loadAllSymbolsAsync(definition).catch(createErrorHandler())) ?? [];

		return symbols;
	};

	return useQuery<eXpress.core.Symbol[]>({
		queryKey: ["use-symbols", definition?.designId],
		queryFn: loadSymbols,
		...reactQueryNoReloadOptions,
	});
}

/**
 * Get the count of symbols
 */
export function useSymbolsCount() {
	const { data: symbols } = useSymbols();
	const definition = useDefinition();

	if (!definition || !definition.canChangeDesign()) return 0;

	return symbols?.length ?? 0;
}
